import { equipmentAPI} from "api";
export const getFileUplaodAPI = () => {
    return equipmentAPI.get('api/bulkupload/getuploadinstrumenthistory/getall?page=1&size=100').then((res) => res);
}
export const downloadFileAPI = (payload) => {
    let apiUrl = `api/bulkupload/getinstrumentsfile?fileName=${payload}`
    return equipmentAPI.get(apiUrl).then((res) => res);
  }